import React from 'react';
import { styled } from 'styled-components';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { Colors } from '../../../../play-core/styles/Colors';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Shadows } from '../../../../play-core/styles/Shadows';
import { ellipsis } from '../../../../play-core/styles/style-helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DropdownButton = ({
  isOpen,
  title,
  isLoading,
  isDisabled = false,
  onClick
}) => /*#__PURE__*/_jsx(ToggleButton, {
  "aria-expanded": isOpen,
  onClick: onClick,
  isOpen: isOpen,
  isDisabled: isDisabled,
  disabled: isDisabled,
  children: /*#__PURE__*/_jsxs(ButtonContent, {
    children: [/*#__PURE__*/_jsx(ButtonTitle, {
      children: title
    }), !isDisabled && /*#__PURE__*/_jsx(ActionIcon, {
      isOpen: isOpen && !isLoading,
      children: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: "down"
      })
    })]
  })
});
export const toggleButtonHeight = 48;
const dropdownTheme = theme => {
  if (theme.type === 'white') {
    return {
      background: Colors.SRF_fafaf8,
      backgroundHover: Colors.SRF_ebebe5,
      backgroundOpen: Colors.SRF_ebebe5,
      borderColor: 'transparent',
      fontColor: Colors.SRF_4e4d47,
      fontColorDisabled: Colors.SRF_4e4d47,
      iconFontColor: Colors.SRF_4e4d47
    };
  }
  if (theme.type === 'outline') {
    return {
      background: 'transparent',
      backgroundHover: Colors.GREY_454545,
      backgroundOpen: Colors.GREY_4a4a4a,
      borderColor: Colors.GREY_969696,
      fontColor: Colors.GREY_d2d2d2,
      fontColorDisabled: Colors.GREY_969696,
      iconFontColor: Colors.GREY_d2d2d2
    };
  }
  if (theme.type === 'darker') {
    return {
      background: Colors.GREY_3a3a3a,
      backgroundHover: Colors.GREY_4a4a4a,
      backgroundOpen: Colors.GREY_4a4a4a,
      borderColor: 'transparent',
      fontColor: Colors.GREY_d2d2d2,
      fontColorDisabled: Colors.GREY_e1e1e1,
      iconFontColor: Colors.GREY_969696
    };
  }
  return {
    background: Colors.GREY_2a2a2a,
    backgroundHover: Colors.GREY_3a3a3a,
    backgroundOpen: Colors.GREY_3a3a3a,
    borderColor: 'transparent',
    fontColor: Colors.GREY_d2d2d2,
    fontColorDisabled: Colors.GREY_e1e1e1,
    iconFontColor: Colors.GREY_969696
  };
};
const ButtonTitle = styled.span.withConfig({
  displayName: "DropdownButton__ButtonTitle",
  componentId: "sc-lrqfjd-0"
})(["display:block;text-align:start;", ";"], ellipsis);
export const ToggleButton = styled.button.withConfig({
  displayName: "DropdownButton__ToggleButton",
  componentId: "sc-lrqfjd-1"
})(["", ";", ";position:relative;height:", "px;width:100%;padding:10px 15px;background-color:", ";color:", ";border-radius:2px;", ";transition:background-color 0.2s ease-in,box-shadow 0.2s ease-in;&:hover{background-color:", ";", ";}"], Fonts.regular(16), ({
  isOpen
}) => isOpen ? Shadows.applyDouble(4) : Shadows.applyDouble(2), toggleButtonHeight, props => props.isOpen ? dropdownTheme(props.theme).backgroundOpen : dropdownTheme(props.theme).background, props => props.isDisabled ? dropdownTheme(props.theme).fontColorDisabled : dropdownTheme(props.theme).fontColor, ({
  theme
}) => dropdownTheme(theme).borderColor !== 'transparent' && `border: 1px solid ${dropdownTheme(theme).borderColor}`, props => props.isDisabled ? dropdownTheme(props.theme).background : dropdownTheme(props.theme).backgroundHover, Shadows.applyDouble(4));
export const ButtonContent = styled.div.withConfig({
  displayName: "DropdownButton__ButtonContent",
  componentId: "sc-lrqfjd-2"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;"]);
export const ActionIcon = styled.div.withConfig({
  displayName: "DropdownButton__ActionIcon",
  componentId: "sc-lrqfjd-3"
})(["color:", ";display:flex;font-size:24px;transform:", ";transition:transform 0.15s ease-in-out;"], props => dropdownTheme(props.theme).iconFontColor, ({
  isOpen
}) => isOpen ? 'rotate(180deg)' : 'rotate(0)');